import React from "react";
import { useForm, useWatch } from "react-hook-form";
import Button from "../../../../components/common/button";
import CustomModal from "../../../../components/common/modal";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import StepFormTabs from "../../../../components/common/stepFormTabs";
import { Col, Row } from "react-bootstrap";
import Radio from "../../../../components/common/FormFields/radio";
import Input from "../../../../components/common/FormFields/input";
import CustomSelect from "../../../../components/common/FormFields/select";
import {
  setAttributesFormForm,
  setModalForm,
} from "../../../../store/slices/product/productSlice";
import store from "../../../../store";
import Checkbox from "../../../../components/common/FormFields/checkbox";
import { getDependentAttributeValues } from "../../../../service/productVariant/filterService";
import { getParamsFromURL, renderLabel } from "../../../../utils/helper";
import { useLocation } from "react-router-dom";
import { getChildAttributeValue } from "../../../../service/order/orderService";
import Date from "../../../../components/common/FormFields/date";

const ProductModal = ({ show, handleClose }) => {
  const location = useLocation();
  const productAttributes = useSelector(
    (state) => state.product.productAttributes.child_product_list,
  );

  const attributeForm = useSelector(
    (state) => state.product.attributeForm.formState,
  );
  const modalState = useSelector(
    (state) => state.product.attributeForm.modalState,
  );
  const customerData = useSelector((state) => state.common.customerData);

  const [currentStep, setCurrentStep] = useState(0);
  const [productId, setProductId] = useState(null);
  const [productTabs, setProductTabs] = useState([]);
  const {
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
    handleSubmit,
  } = useForm({ mode: "onChange", defaultValues: attributeForm });

  const ownershipValue = useWatch({ control, name: "ownership" });

  useEffect(() => {
    if (show) {
      store.dispatch(setModalForm(attributeForm));
    }
  }, [show, attributeForm]);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setProductId(params["entityid"]);
        } else {
          console.error("Error fetching params");
        }
      });
    };
    fetchCode();
  }, [location]);

  const handleApply = () => {
    store.dispatch(setAttributesFormForm(modalState));
    handleClose();
  };

  useEffect(() => {
    if (productAttributes && productAttributes.length > 0) {
      const tabs = productAttributes.map((child) => ({
        name: child.name,
        entityid: child.entityid,
        attributes: child.product_attributes_list?.map((attribute) => ({
          label: attribute.name,
          lov: attribute.product_attribute_lov || [],
          element_type: attribute.element_type,
          attribute_key: attribute.attribute_key,
          isDisabled: attribute.is_disabled,
          isRequired: attribute.required,
          parent_key: attribute.parent_key || null,
          parent_attribute_key: attribute.parent_attribute_key || null,
          attribute_id: attribute.entityid || null,
          entityid: attribute.entityid,
          min: attribute.filter_min,
          max: attribute.filter_max,
          maxLength: attribute.max_length,
          description: attribute.description,
        })),
        addons: child.product_addon_list?.map((addon) => ({
          label: addon.label,
          name: addon.name || "",
          element_type: addon.element_type,
          lov: addon.product_addon_lov || [],
          entityid: addon.entityid,
          min: addon.min_value,
          max: addon.max_value,
          isDisabled: addon.is_disabled,
          default_value: addon.default_value,
          maxLength: addon.max_length,
        })),
      }));
      setProductTabs(tabs);
    }
  }, [productAttributes]);

  useEffect(() => {
    if (attributeForm && productId) {
      Object.entries(attributeForm).forEach(([entityid, attributes]) => {
        Object.entries(attributes).forEach(([attributeKey, value]) => {
          if (!getValues(attributeKey)) {
            handleChange(entityid, attributeKey, value);
          }
        });
      });
    }
  }, [attributeForm, productId, setValue]);

  useEffect(() => {
    if (modalState) {
      Object.entries(modalState).forEach(([entityid, attributes]) => {
        Object.entries(attributes).forEach(([attributeKey, value]) => {
          setValue(attributeKey, value);
        });
      });
    }
  }, [modalState, setValue]);

  const findEntityId = (attributeKey) => {
    for (let item of productTabs) {
      for (let attribute of item.attributes) {
        if (attribute.attribute_key === attributeKey) {
          return item.entityid;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    if (customerData?.qualification && productTabs.length > 0) {
      const entityId = findEntityId("qualification");
      if (entityId) {
        handleChange(entityId, "qualification", customerData.qualification);
      }
    }
    if (customerData?.property_name && productTabs.length > 0) {
      const entityId = findEntityId("property");
      if (entityId) {
        handleChange(entityId, "property", customerData.property_name);
      }
    }
  }, [customerData, productTabs]);

  useEffect(() => {
    if (productTabs.length > 0) {
      productTabs.forEach((tab) => {
        tab.addons?.forEach((addon) => {
          if (addon.element_type === "checkbox") {
            const defaultValue = addon.default_value === "yes" ? "yes" : "no";

            setValue(addon.name, defaultValue);

            handleChange(tab.entityid, addon.name, defaultValue);
          }
        });
      });
    }
  }, [productTabs, setValue]);

  const handleChange = (entityid, attributeKey, value, showValue = null) => {
    const currentState = store.getState().product.attributeForm.modalState;
    let updatedEntity = {
      ...currentState[entityid],
    };

    // const currentOwnership = getValues("ownership");
    // if (
    //   attributeKey === "ownership" &&
    //   value === "Rented" &&
    //   updatedEntity.building_cover
    // ) {
    //   delete updatedEntity.building_cover;
    //   setValue("building_cover", "");
    // }

    // if (!(attributeKey === "building_cover" && currentOwnership === "Rented")) {
    //   updatedEntity[attributeKey] = value;
    // }
    updatedEntity[attributeKey] = value;

    // Handle initialization/resizing for additional_variants
    const tab = productTabs.find((t) => t.entityid === entityid);
    const variantField =
      tab?.attributes?.find(
        (a) =>
          a.element_type === "additional_variants" &&
          a.parent_key === attributeKey,
      ) ||
      tab?.addons?.find(
        (a) =>
          a.element_type === "additional_variants" &&
          a.parent_key === attributeKey,
      );

    if (variantField) {
      const count = parseInt(value) || 0;
      const vKey = variantField.attribute_key || variantField.name;
      const currentArray = updatedEntity[vKey] || [];

      if (count === 0) {
        delete updatedEntity[vKey];
      } else {
        // Resize array and keep existing data
        const newArray = Array.from(
          { length: count },
          (_, i) => currentArray[i] || {},
        );
        updatedEntity[vKey] = newArray;
      }
    }

    // Clear dependent items (attributes OR addons) that are not valid anymore
    const allItems = [...(tab?.attributes || []), ...(tab?.addons || [])];

    allItems.forEach((item) => {
      const fieldKey = item.attribute_key || item.name;
      if (item.parent_key === attributeKey) {
        const parentValueNum = parseInt(value) || 0;
        const shouldShow =
          (attributeKey === "ownership" && value !== "Rented") ||
          !attributeKey ||
          String(value).toLowerCase() === "yes" ||
          parentValueNum > 0;

        if (!shouldShow && updatedEntity[fieldKey]) {
          delete updatedEntity[fieldKey];
          setValue(fieldKey, ""); // Clear in form state
        }
      }
    });

    let updatedState = {
      ...currentState,
      [entityid]: updatedEntity,
    };

    setValue(attributeKey, showValue ? showValue : value);
    handleDependentValue(entityid, attributeKey, value);

    const currentTabIndex = productTabs.findIndex(
      (tab) => tab.entityid === entityid,
    );

    for (let i = currentTabIndex + 1; i < productTabs.length; i++) {
      const nextTab = productTabs[i];
      const hasAttribute = nextTab.attributes.some(
        (attr) => attr.attribute_key === attributeKey,
      );

      if (hasAttribute) {
        updatedState = {
          ...updatedState,
          [nextTab.entityid]: {
            ...updatedState[nextTab.entityid],
            [attributeKey]: value,
          },
        };
      }
    }
    store.dispatch(setModalForm(updatedState));
  };

  const handleArrayChange = (entityid, attributeKey, index, subKey, value) => {
    const currentState = store.getState().product.attributeForm.modalState;
    const entityState = { ...currentState[entityid] };
    const arrayData = [...(entityState[attributeKey] || [])];

    arrayData[index] = {
      ...arrayData[index],
      [subKey]: value,
    };

    const updatedState = {
      ...currentState,
      [entityid]: {
        ...entityState,
        [attributeKey]: arrayData,
      },
    };
    store.dispatch(setModalForm(updatedState));
  };
  const handleDependentValue = (entityid, key, value) => {
    if (key === "qualification") {
      getDependentAttributeValues(productId, key, value).then((response) => {
        if (response) {
          handleChange(
            entityid,
            "doctor_category",
            response.default_values,
            response.attribute_lov_label,
          );
          return;
        }
      });
    } else if (key === "pincode") {
      getDependentAttributeValues(productId, key, value).then((response) => {
        if (response) {
          handleChange(
            entityid,
            "eq_zone",
            response.default_values,
            response.attribute_lov_label,
          );
          return;
        }
      });
    } else {
      const processedValue = value === true ? "true" : value;

      productTabs.forEach((tab) => {
        tab.attributes?.forEach((attr) => {
          if (attr.parent_attribute_key === key || attr.parent_key === key) {
            getChildAttributeValue(attr.entityid, processedValue).then(
              (res) => {
                if (res) {
                  // Check if response has dependent_attribute_value
                  const dependentValue =
                    res.attribute_value !== undefined
                      ? res.attribute_value
                      : res;

                  if (dependentValue) {
                    handleChange(
                      tab.entityid,
                      attr.attribute_key,
                      dependentValue,
                    );
                  }
                }
              },
            );
          }
        });
      });
    }
    return;
  };

  const getCurrentTabDetails = () => {
    const currentTab = productTabs[currentStep];
    if (!currentTab) return <div>Loading...</div>;

    const isTwoColumnLayout =
      currentTab.attributes.length > 3 || currentTab.addons.length > 3;

    const chunkArray = (array, size) => {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        const chunk = array.slice(i, i + size);
        if (chunk.length > 0) {
          result.push(chunk);
        }
      }
      return result;
    };

    const renderAttributes = (attributes) => {
      if (!attributes || attributes.length === 0) return null;
      const groupedAttributes = chunkArray(attributes, 2);

      return groupedAttributes.map((group, rowIndex) => (
        <Row key={rowIndex} className="attribute-group">
          {group.map((attribute, index) => {
            // if (
            //   attribute.attribute_key === "building_cover" &&
            //   ownershipValue === "Rented"
            // ) {
            //   return null;
            // }
            const parentValue = watch(attribute.parent_key);
            const parentValueNum = parseInt(parentValue) || 0;
            const shouldShow =
              (attribute.parent_key === "ownership" &&
                parentValue !== "Rented") ||
              !attribute.parent_key ||
              String(parentValue).toLowerCase() === "yes" ||
              parentValueNum > 0;

            if (!shouldShow) return null;

            if (attribute.element_type === "additional_variants") {
              const count = parentValueNum;
              const arrayData =
                modalState[currentTab.entityid]?.[attribute.attribute_key] ||
                [];

              const subFields = attributes.filter(
                (a) =>
                  a.element_type !== "additional_variants" &&
                  a.attribute_key !== attribute.parent_key,
              );

              return (
                <React.Fragment key={index}>
                  {Array.from({ length: count }).map((_, idx) =>
                    subFields.map((subAttr, sIdx) => (
                      <Col md={6} key={`${idx}-${sIdx}`} style={{ marginBottom: "10px" }}>
                        {subAttr.element_type === "dropdown" ? (
                          <CustomSelect
                            name={`${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`}
                            control={control}
                            options={subAttr.lov.map((o) => ({
                              value: o.attribute_value,
                              label: o.name,
                            }))}
                            label={`Member ${idx + 1} ${subAttr.label}`}
                            errors={errors}
                            value={
                              subAttr.lov
                                .map((o) => ({
                                  value: o.attribute_value,
                                  label: o.name,
                                }))
                                .find(
                                  (o) =>
                                    o.value ===
                                    arrayData[idx]?.[subAttr.attribute_key],
                                ) || null
                            }
                            onChange={(opt) =>
                              handleArrayChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                idx,
                                subAttr.attribute_key,
                                opt.value,
                              )
                            }
                          />
                        ) : subAttr.element_type === "text" ? (
                          <Input
                            type="text"
                            name={`${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`}
                            control={control}
                            label={`Member ${idx + 1} ${subAttr.label}`}
                            placeholder="Enter"
                            errors={errors}
                            value={
                              arrayData[idx]?.[subAttr.attribute_key] || ""
                            }
                            onChange={(e) =>
                              handleArrayChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                idx,
                                subAttr.attribute_key,
                                e.target.value,
                              )
                            }
                            rules={{
                              required: subAttr.isRequired
                                ? { value: true, message: "Required field" }
                                : false,
                            }}
                          />
                        ) : subAttr.element_type === "date" ? (
                          <Date
                            type="date"
                            name={`${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`}
                            control={control}
                            label={`Member ${idx + 1} ${subAttr.label}`}
                            errors={errors}
                            value={
                              arrayData[idx]?.[subAttr.attribute_key] || ""
                            }
                            onChange={(e) =>
                              handleArrayChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                idx,
                                subAttr.attribute_key,
                                e.target.value,
                              )
                            }
                            rules={{
                              required: subAttr.isRequired
                                ? { value: true, message: "Required field" }
                                : false,
                            }}
                            min={subAttr.min}
                            max={subAttr.max}
                          />
                        ) : null}
                      </Col>
                    )),
                  )}
                </React.Fragment>
              );
            }

            const storedRawValue =
              modalState[currentTab.entityid]?.[attribute.attribute_key];

            const storedValue =
              attribute.lov?.find(
                (option) => option.attribute_value === storedRawValue,
              )?.name || storedRawValue;

            return (
              <Col md={6} key={index}>
                {attribute.element_type === "dropdown" ||
                attribute.element_type === "range" ? (
                    <>
                  <CustomSelect
                    key={attribute.attribute_key}
                    name={attribute.attribute_key}
                    control={control}
                    options={attribute.lov.map((option) => ({
                      value: option.attribute_value,
                      label: option.name,
                    }))}
                    defaultValue={getValues(attribute.attribute_key)}
                    // value={
                    //   attribute.lov
                    //     .map((option) => ({
                    //       value: option.attribute_value,
                    //       label: option.name,
                    //     }))
                    //     .find((option) => option.value === storedRawValue) ||
                    //   null
                    // }
                    disabled={attribute.isDisabled === 1}
                    label={renderLabel(attribute.label, attribute.description)}
                    errors={errors}
                    rules={{
                      required: attribute.isRequired
                        ? { value: true, message: "Required field" }
                        : false,
                    }}
                    onChange={(selectedOption) => {
                      handleChange(
                        currentTab.entityid,
                        // "product_attribute_list",
                        attribute.attribute_key,
                        selectedOption?.value,
                      );
                    }}

                  />
                   {(() => {
                      const selectedOption = attribute.lov?.find(
                        (o) => o.attribute_value === storedRawValue,
                      );
                      return (
                        selectedOption?.description && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              // marginTop: "4px",
                            }}
                          
                             dangerouslySetInnerHTML={{ __html: selectedOption.description }}
                          />
                        )
                      );
                    })()}
                  </>
                ) : attribute.element_type === "number" ||
                  attribute.element_type === "range_number" ? (
                  <Input
                    key={attribute.attribute_key}
                    type="tel"
                    name={attribute.attribute_key}
                    control={control}
                    placeholder={`Enter ${attribute.label}`}
                    label={attribute.label}
                    errors={errors}
                    rules={{
                      required: attribute.isRequired
                        ? { value: true, message: "Required field" }
                        : false,
                      min: {
                        value: attribute.min,
                        message: `Value must be at least ${attribute.min}`,
                      },
                      max: {
                        value: attribute.max,
                        message: `Value must be no more than ${attribute.max}`,
                      },
                    }}
                    minLength={attribute?.minLength}
                    maxLength={attribute?.maxLength}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                    }}
                    defaultValue={attribute.value}
                    // defaultValue={getValues(attribute.attribute_key) || ""}
                    // value={watch(attribute.attribute_key) || ""}
                    onBlur={(e) => {
                      const value = e.target.value;
                      handleChange(
                        currentTab.entityid,
                        // "product_attribute_list",
                        attribute.attribute_key,
                        value,
                      );
                      trigger(attribute.attribute_key);
                    }}
                  />
                ) : attribute.element_type === "select" ? (
                  <div className="radio-group-container">
                    <label className="radio-group-label">
                      {attribute.label}
                    </label>
                    <div className="radio-group">
                      {attribute.lov.map((option, optionIndex) => (
                        <div
                          className="radio-wrapper horizontal"
                          key={optionIndex}
                        >
                          <Radio
                            key={option.entityid}
                            name={attribute.attribute_key}
                            control={control}
                            label={option.name}
                            value={option.attribute_value}
                            errors={errors}
                            className="radio-style"
                            rules={{ required: "Please select an option" }}
                            onInputChange={(e) => {
                              const selectedValue = e.target.value;
                              handleChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                selectedValue,
                              );
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : attribute.element_type === "badge" ||
                  attribute.element_type === "text" ? (
                  <Input
                    key={attribute.attribute_key}
                    type="text"
                    name={attribute.attribute_key}
                    control={control}
                    placeholder={`Enter ${attribute.label}`}
                    label={attribute.label}
                    errors={errors}
                    rules={{
                      required: "This field is required",
                    }}
                    value={getValues(attribute.attribute_key) || ""}
                    disabled={attribute.isDisabled === 1}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleChange(
                        currentTab.entityid,
                        attribute.attribute_key,
                        value,
                      );
                      trigger(attribute.attribute_key);
                    }}

                    // disabled
                  />
                ) : null}
              </Col>
            );
          })}
        </Row>
      ));
    };

    const renderAddOns = (addOns) => {
      if (!addOns || addOns.length === 0) return null;
      const groupedAddOns = chunkArray(addOns, 2);
      // Group into pairs

      return groupedAddOns.map((group, rowIndex) => (
        <Row key={rowIndex} className="attribute-group">
          {group?.map((addon, index) => (
            <Col md={6} key={index}>
              {addon.element_type === "checkbox" ? (
                <Checkbox
                  key={addon.name}
                  name={addon.name}
                  control={control}
                  options={[addon]}
                  errors={errors}
                  disabled={addon.isDisabled === 1}
                  onInputChange={(name, checked) => {
                    const value = checked ? "yes" : "no";
                    handleChange(currentTab.entityid, addon.name, value);
                  }}
                />
              ) : addon.element_type === "select" ? (
                <div className="radio-group-container">
                  <label className="radio-group-label">{addon.label}</label>
                  <div className="radio-group">
                    {addon.lov.map((option, optionIndex) => (
                      <div
                        className="radio-wrapper horizontal"
                        key={optionIndex}
                      >
                        <Radio
                          key={`addon_${index}`}
                          name={`addon_${index}`}
                          control={control}
                          label={option.name}
                          value={option.value}
                          errors={errors}
                          className="radio-style"
                          // rules={{
                          //   required: "Please select an option",
                          // }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <Input
                  key={`${addon.name}`}
                  type="tel"
                  name={`${addon.name}`}
                  control={control}
                  placeholder={`Enter ${addon.label}`}
                  label={`${addon.label}`}
                  errors={errors}
                  rules={{
                    required: addon.isRequired
                      ? { value: true, message: "Required field" }
                      : false,
                    min: {
                      value: addon.min,
                      message: `Value must be at least ${addon.min}`,
                    },
                    max: {
                      value: addon.max,
                      message: `Value must be no more than ${addon.max}`,
                    },
                  }}
                  disabled={addon.isDisabled === 1}
                  minLength={addon?.minLength}
                  maxLength={addon?.maxLength}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  value={getValues(addon.name) || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange(
                      currentTab.entityid,
                      // "product_addon_list",
                      addon.name,
                      value,
                    );
                    trigger(addon.attribute_key);
                  }}
                />
              )}
            </Col>
          ))}
        </Row>
      ));
    };

    return (
      <div>
        <div className="cover-details">
          <div
            className={`form--content--wrapper ${
              isTwoColumnLayout ? "two-column" : "single-column"
            }`}
          >
            <Row>
              <Col>{renderAttributes(currentTab.attributes)}</Col>
            </Row>

            {currentTab.addons && currentTab.addons.length > 0 && (
              <>
                <div className="addons-header">Add Ons</div>
                <Row>
                  <Col>{renderAddOns(currentTab.addons)}</Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <CustomModal show={show} handleClose={handleClose} size={"lg"}>
      <div className="product--modal--body">
        <div className="step-form-tab-container">
          <StepFormTabs
            steps={productTabs}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            direction="horizontal"
            enableClick={true}
          />
        </div>
        <div className="cover-container">{getCurrentTabDetails()}</div>
        <div className="btn-wrapper">
          <Button
            type="button"
            variant="primaryBox"
            label="Apply"
            onClick={handleApply}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default ProductModal;
